import React from "react";
import prod1 from "../../images/solutions.svg";
import prod2 from "../../images/server.svg";
import prod4 from "../../images/server.svg";

import CategoryBanner from "../CategoryBanner/CategoryBanner";
// Main component for SolutionsMarketplace
const SolutionsMarketplace = () => {
  const categoryImage = {
    "DCS-DT1":prod2,
    "VERTICAL-EDGE-SERVER": prod4,
    "VCU": prod1,
    "CLOUD-GW":prod1,

  }
  return (
    <>
    {/* component to display all category and products */}
     <CategoryBanner title="Marketplace for partners to buy & sell" MarketCategoryType="ec9f5f01-d62c-440a-9e1e-b78b657f6da4" categoryImage={categoryImage}/>
    </>
  );
};

export default SolutionsMarketplace;

